(() => {
  /**
   * product slider thumbnails
   */
  const container = document.querySelector('.Product__SlideshowNavScroller');
  if(!container) return;
  const thumbnailsPosition = container.getAttribute('data-position');
  const thumbnails = container.querySelectorAll('.Product__SlideshowNavImage');
  let tempIndex = Array.from(thumbnails).findIndex((t) =>
    t.classList.contains('is-selected')
  );
  const firstThumb = thumbnails[0];
  const lastThumb = thumbnails[thumbnails.length - 1];
  const navButtons = document.querySelectorAll(
    '.Product__SlideshowNav--thumbnails-nav'
  );
  const navButtonTop = document.querySelector(
    '.Product__SlideshowNav--thumbnails-nav.top'
  );
  const navButtonBottom = document.querySelector(
    '.Product__SlideshowNav--thumbnails-nav.bottom'
  );
  const mainGallery = document.querySelector('.Product__Slideshow.Carousel');

  const observeOptions = { root: container };
  const observerTop = new IntersectionObserver((entries) => {
    for (const { isIntersecting } of entries) {
      navButtonTop.classList.toggle('invisible', isIntersecting);
    }
  }, observeOptions);
  observerTop.observe(firstThumb);

  const observerBottom = new IntersectionObserver((entries) => {
    for (const { isIntersecting } of entries) {
      navButtonBottom.classList.toggle('invisible', isIntersecting);
    }
  }, observeOptions);
  observerBottom.observe(lastThumb);

  navButtons.forEach((slideshowNav) =>
    slideshowNav.addEventListener('click', (e) => {
      const currentTarget = e.currentTarget;
      const direction = currentTarget.getAttribute('data-direction');
      const scrollDistance = thumbnailsPosition === 'left'
        ? container.offsetWidth + 8
        : container.offsetHeight + 8;

      container.scrollBy({
        top: thumbnailsPosition === 'left'
          ? direction === 'top'
            ? scrollDistance * -1
            : scrollDistance
          : 0,
        left: thumbnailsPosition === 'left'
          ? 0
          : direction === 'top'
            ? scrollDistance * -1
            : scrollDistance,
        behavior: 'smooth'
      });
    })
  );

  container.addEventListener('mouseleave', () => {
    thumbnails[tempIndex].click();
    thumbnails[tempIndex].classList.remove('o-sel');
  });

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      if (!thumb.classList.contains('t-sel')) {
        return;
      }

      thumbnails[tempIndex].classList.remove('o-sel');
      tempIndex = index;
    });

    thumb.addEventListener('mouseenter', () => {
      thumb.click();

      // add mini delay to run click listener first
      setTimeout(() => {
        thumbnails[tempIndex].classList.add('o-sel');
        thumb.classList.add('t-sel');
      }, 50);
    });

    thumb.addEventListener('mouseleave', () => thumb.classList.remove('t-sel'));
  });

  document.addEventListener('productSlide:willChange', ({ detail: index, target: target }) => {
    if(target.activeElement && target.activeElement.classList.contains('ProductList')) return;
    
    tempIndex = index;

    thumbnails[index].scrollIntoView({
      block: 'nearest',
      inline: 'nearest',
      behavior: 'smooth'
    });
  });

  function updateOnColorChange() {
    const hasMoreThanOneColor =
      firstThumb.parentElement.querySelectorAll(
        '.Product__SlideshowNavImage:not([hidden])'
      ).length > 1;
    if (hasMoreThanOneColor) {
      navButtons.forEach((button) => button.removeAttribute('hidden'));
      if (mainGallery) {
        mainGallery
          .querySelectorAll('.flickity-prev-next-button')
          .forEach((button) => button.removeAttribute('hidden'));
      }
    } else {
      navButtons.forEach((button) => button.setAttribute('hidden', 'true'));
      if (mainGallery) {
        mainGallery
          .querySelectorAll('.flickity-prev-next-button')
          .forEach((button) => button.setAttribute('hidden', 'true'));
      }
    }
  }
  updateOnColorChange();
  document.documentElement.addEventListener(
    'variant-images:change',
    updateOnColorChange
  );
})();

/**
 * Products TABS scroll
 */
document?.addEventListener('DOMContentLoaded', ()=> {
  let buttonElements = document.querySelectorAll('.Product__Wrapper .Collapsible__Button');
  let productTabs = document.querySelector('.Product__Tabs');
  buttonElements.forEach(buttonElement => {
    buttonElement.addEventListener('click', (e) => {
      productTabs.scrollIntoView({ behavior: "smooth", block: "start" });      
    })
  })  
});
